module.exports = __webpack_public_path__ + "img/file_pdf.c949c4f4.png";